/* ============================================
   HealthWatch Theme - Core JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initCartDrawer();
  initFAQ();
  initStickyHeader();
  initQuantitySelectors();
});

/* --- Mobile Menu --- */
function initMobileMenu() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.header-nav__list');
  const overlay = document.querySelector('.mobile-overlay');

  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    toggle.classList.toggle('active');
    nav.classList.toggle('open');
    if (overlay) overlay.classList.toggle('active');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  });

  if (overlay) {
    overlay.addEventListener('click', () => {
      toggle.classList.remove('active');
      nav.classList.remove('open');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
}

/* --- Sticky Header --- */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });
}

/* --- Cart Drawer --- */
function initCartDrawer() {
  const openBtns = document.querySelectorAll('[data-cart-toggle]');
  const closeBtn = document.querySelector('.cart-drawer__close');
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer = document.querySelector('.cart-drawer');

  function openCart() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  // Expose globally
  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;
}

/* --- Cart API Functions --- */
async function fetchCart() {
  const res = await fetch(window.routes.cart_url + '.js');
  return await res.json();
}

async function addToCart(variantId, quantity = 1) {
  const res = await fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  });
  const data = await res.json();
  await refreshCart();
  if (window.openCartDrawer) window.openCartDrawer();
  return data;
}

async function changeCartItem(key, quantity) {
  const res = await fetch(window.routes.cart_change_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  });
  const data = await res.json();
  await refreshCart();
  return data;
}

async function refreshCart() {
  const cart = await fetchCart();
  updateCartDrawer(cart);
  updateCartCount(cart.item_count);
}

function updateCartCount(count) {
  const badges = document.querySelectorAll('.cart-count-badge');
  badges.forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

function updateCartDrawer(cart) {
  var itemsContainer = document.querySelector('.cart-drawer__items');
  var subtotalEl = document.querySelector('.cart-drawer__subtotal-amount');

  if (!itemsContainer) return;

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>' + window.cartStrings.empty + '</p></div>';
  } else {
    itemsContainer.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-drawer-item" data-key="' + item.key + '">' +
        '<div class="cart-drawer-item__image">' +
          '<a href="' + item.url + '">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[^.]+)$/, '_180x$1') : '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png') + '" alt="' + item.title + '" loading="lazy">' +
          '</a>' +
        '</div>' +
        '<div class="cart-drawer-item__info">' +
          '<a href="' + item.url + '" class="cart-drawer-item__title">' + item.product_title + '</a>' +
          (item.variant_title ? '<span class="cart-drawer-item__variant">' + item.variant_title + '</span>' : '') +
          '<div class="cart-drawer-item__bottom">' +
            '<div class="quantity-selector quantity-selector--small">' +
              '<button class="quantity-selector__btn" onclick="changeCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')">-</button>' +
              '<span class="quantity-selector__value">' + item.quantity + '</span>' +
              '<button class="quantity-selector__btn" onclick="changeCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
            '<span class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button class="cart-drawer-item__remove" onclick="changeCartItem(\'' + item.key + '\', 0)">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  // Update rewards progress bar
  updateRewardsBar(cart);

  // Show/hide upsell section
  var upsellSection = document.querySelector('[data-upsell-section]');
  if (upsellSection) {
    upsellSection.style.display = cart.items.length > 0 ? '' : 'none';

    // Check if screen protector is already in cart
    var hasScreenProtector = cart.items.some(function(item) {
      return item.product_title.toLowerCase().indexOf('screen protector') > -1;
    });
    if (hasScreenProtector) {
      upsellSection.style.display = 'none';
    }
  }
}

function updateRewardsBar(cart) {
  var fill = document.querySelector('[data-rewards-fill]');
  var message = document.querySelector('[data-rewards-message]');
  var milestone1 = document.querySelector('[data-milestone="1"]');
  var milestone2 = document.querySelector('[data-milestone="2"]');

  if (!fill || !message) return;

  var hasItems = cart.items.length > 0;
  var hasScreenProtector = cart.items.some(function(item) {
    return item.product_title.toLowerCase().indexOf('screen protector') > -1;
  });

  // Reward tiers:
  // Tier 1: Any item in cart = Free E-Book (50% fill)
  // Tier 2: Screen protector added = Free Milanese Loop (100% fill)
  var hint = document.querySelector('[data-rewards-hint]');

  if (!hasItems) {
    fill.style.width = '0%';
    message.textContent = 'Add an item to unlock your first reward!';
    if (milestone1) milestone1.classList.remove('unlocked');
    if (milestone2) milestone2.classList.remove('unlocked');
    if (hint) hint.style.display = 'none';
  } else if (hasItems && !hasScreenProtector) {
    fill.style.width = '50%';
    message.innerHTML = '🎉 <strong>Free E-Book unlocked!</strong>';
    if (milestone1) milestone1.classList.add('unlocked');
    if (milestone2) milestone2.classList.remove('unlocked');
    if (hint) { hint.style.display = ''; hint.innerHTML = 'Add a Screen Protector to get a <strong>FREE Milanese Loop</strong>!'; }
  } else {
    fill.style.width = '100%';
    message.innerHTML = '🎉 <strong>All rewards unlocked!</strong> Free E-Book + Free Milanese Loop included!';
    if (milestone1) milestone1.classList.add('unlocked');
    if (milestone2) milestone2.classList.add('unlocked');
    if (hint) hint.style.display = 'none';
  }
}

function initUpsell() {
  var addBtn = document.querySelector('[data-upsell-add]');
  if (!addBtn) return;

  addBtn.addEventListener('click', function() {
    addBtn.disabled = true;
    addBtn.textContent = '...';

    // Try to find a screen protector product and add it
    // Using the Shopify search API to find the product
    fetch('/search/suggest.json?q=screen+protector&resources[type]=product&resources[limit]=1')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (products && products.length > 0) {
          var productUrl = products[0].url + '.js';
          return fetch(productUrl);
        }
        throw new Error('Product not found');
      })
      .then(function(res) { return res.json(); })
      .then(function(product) {
        var variantId = product.variants[0].id;
        return addToCart(variantId, 1);
      })
      .then(function() {
        addBtn.textContent = '✓ Added';
      })
      .catch(function() {
        addBtn.textContent = 'Add';
        addBtn.disabled = false;
      });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initUpsell();
});

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* --- FAQ Accordion --- */
function initFAQ() {
  const faqItems = document.querySelectorAll('.faq-item__question');
  faqItems.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const wasActive = item.classList.contains('active');

      // Close all
      item.parentElement.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));

      // Open clicked if wasn't active
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });
}

/* --- Quantity Selectors --- */
function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-selector__input');
    const minus = selector.querySelector('[data-qty-minus]');
    const plus = selector.querySelector('[data-qty-plus]');

    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change'));
    });
  });
}

// Expose cart functions globally
window.addToCart = addToCart;
window.changeCartItem = changeCartItem;
window.refreshCart = refreshCart;

// Initialize cart on load
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();
});
